import React from "react";
import { ACCENT } from "../../styles/deskGlass";

/** Palette-matched robot glyph; `auto` draws a loop for auto-robo mode. */
export default function AgentBotIcon({ size = 14, auto = false, color = ACCENT }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      {auto && (
        <>
          <path
            d="M8 2.2a5.8 5.8 0 1 0 0 11.6 5.8 5.8 0 0 0 0-11.6"
            stroke={color}
            strokeWidth="0.95"
            strokeOpacity="0.65"
            strokeLinecap="round"
            strokeDasharray="2.5 1.8"
          />
          <path
            d="M11.6 3.1l1.1 1.9M12.7 3.1H11"
            stroke={color}
            strokeWidth="0.9"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeOpacity="0.8"
          />
        </>
      )}
      <rect x="4.4" y="5.2" width="7.2" height="5.8" rx="1.1" stroke={color} strokeWidth="1.05" />
      <circle cx="6.2" cy="7.3" r="0.65" fill={color} />
      <circle cx="9.8" cy="7.3" r="0.65" fill={color} />
      <path d="M6.7 9.6h2.6" stroke={color} strokeWidth="0.85" strokeLinecap="round" />
      <path d="M8 5.2V3.9M5.9 3.9h4.2" stroke={color} strokeWidth="0.85" strokeLinecap="round" />
    </svg>
  );
}
